import React from "react";
import { Typography } from "antd";

// Title (+ subtitle) with page-level actions. Actions wrap below the title on phones.
const PageHeader = ({ title, subtitle, extra }) => (
  <div className="acct-page-header">
    <div className="acct-page-header__text">
      <Typography.Title level={3} className="acct-page-header__title">
        {title}
      </Typography.Title>
      {subtitle ? <Typography.Text type="secondary">{subtitle}</Typography.Text> : null}
    </div>
    {extra ? <div className="acct-page-header__extra">{extra}</div> : null}
  </div>
);

export default PageHeader;
